//react
import React from "react";

//router
import { Redirect } from "react-router-dom";

//redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { CoursesLoaded } from 'redux/actions';

//firebase
import { db } from 'assets/firebase';

// @material-ui/style
import withStyles from "@material-ui/core/styles/withStyles";

// core components
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import Tooltip from "@material-ui/core/Tooltip";
import IconButton from "@material-ui/core/IconButton";

//materialKit components
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";

//icons
import Close from "@material-ui/icons/Close";

import CourseEditor from "components/CourseEditor/CourseEditor.jsx";

//google Analytics
import ReactGA from 'react-ga';
ReactGA.initialize('UA-127392840-1');

const styles = {
  cardCategoryWhite: {
    "&,& a,& a:hover,& a:focus": {
      color: "rgba(255,255,255,.62)",
      margin: "0",
      fontSize: "14px",
      marginTop: "0",
      marginBottom: "0"
    },
    "& a,& a:hover,& a:focus": {
      color: "#FFFFFF"
    }
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
    "& small": {
      color: "#777",
      fontSize: "65%",
      fontWeight: "400",
      lineHeight: "1"
    }
  }
};

class CourseList extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      courses: []
    }

    this.courseUpdated = this.courseUpdated.bind(this);
  }

  componentWillMount() {
    this.refreshCourses();
  }

  courseUpdated() {
    this.refreshCourses();
  }

  refreshCourses() {
    db.getCourses().then(snapshot => {
           
      var courses = [];
      snapshot.forEach((doc) => {

          var course = doc.data();
          course.id = doc.id;
          if(!course.Photos)
            course.Photos = [];
          courses.splice(0, 0, course);

          this.setState({courses: courses});
          this.props.onCoursesLoaded(courses);
      });
    });
  }

  visibleText(isVisible) {
    if(isVisible)
      return "Yes";
    else
      return "No";
  }

  render() {
    const { classes } = this.props;

    if (!this.props.user.authenticated) {
      return <Redirect to='/login' />
    }

    ReactGA.pageview("admin.allthingseq.com/courses");

    return (
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <CardHeader color="success">
              <GridContainer>
                <GridItem xs={12} sm={12} md={10}>
                  <h4 className={classes.cardTitleWhite}>Courses</h4>
                  <p className={classes.cardCategoryWhite}>
                    
                  </p>
                </GridItem>
                <GridItem xs={12} sm={12} md={2} style={{textAlign:"right"}}>
                  <Tooltip
                        id="tooltip-top-start"
                        title="Add Course"
                        placement="top"
                        classes={{ tooltip: classes.tooltip }}
                    >
                      <CourseEditor course={{
                        Name: "",
                        Description: "",
                        Photos: [],
                        orgId: this.props.org.id
                        }} 
                        onChange={this.courseUpdated} />
                  </Tooltip>
                </GridItem>
              </GridContainer>
            </CardHeader>
            <CardBody>
              <Table className={classes.table}>
                <TableHead>
                  <TableRow>
                      <TableCell>

                      </TableCell>
                      <TableCell>
                          Title
                      </TableCell>
                      <TableCell>
                          Visible
                      </TableCell>
                      <TableCell>
                          
                      </TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                  {this.state.courses.map(value => (
                    <TableRow key={value.id} className={classes.tableRow}>
                      <TableCell className={classes.tableActions}>
                        <Tooltip
                          id="tooltip-top"
                          title="Edit Course"
                          placement="top"
                          classes={{ tooltip: classes.tooltip }}
                        >
                         <CourseEditor course={value} onChange={this.courseUpdated} />
                        </Tooltip>
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {value.Name}
                      </TableCell>
                      <TableCell className={classes.tableCell}>
                        {this.visibleText(value.IsVisible)}
                      </TableCell>
                      <TableCell className={classes.tableActions}>
                        <Tooltip
                          id="tooltip-top-start"
                          title="Remove Course"
                          placement="top"
                          classes={{ tooltip: classes.tooltip }}
                        >
                          <IconButton
                            aria-label="Close"
                            className={classes.tableActionButton}
                          >
                            <Close className={ classes.tableActionButtonIcon + " " + classes.close } />
                          </IconButton>
                        </Tooltip>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </CardBody>
          </Card>
        </GridItem>
      </GridContainer>
    );
  }
}

const mapStateToProps = state => {
  return state;
}
function mapDispatchToProps(dispatch) {
  return bindActionCreators({onCoursesLoaded: CoursesLoaded }, dispatch);  
}

CourseList = connect(mapStateToProps, mapDispatchToProps)(CourseList);
export default withStyles(styles)(CourseList);



// WEBPACK FOOTER //
// ./src/views/CourseList/CourseList.jsx